import React, { useEffect, useState } from 'react';
import Manage from './manage/listManage';
import ApplyWhite from './apply';
import { useConfig } from '@/apis/ducc';

interface whiteListProps {
  businessType: number; //活动类型 1:主题活动，2:综促活动，3:百亿补贴，4:其他开放报名
  businessId: string;
  title?: string;
  visible: boolean;
  descriptionList?: Array<{ key: string; value: string }>;
}

function findValueFromConfig(obj: any = {}, config: any = {}) {
  const keys = Object.keys(obj);
  if (!keys.length) return false;
  return keys.some((ele) => {
    if (!config[ele]) return false;
    return config[ele].split(',').includes(String(obj[ele])) || config[ele] === 'all';
  });
}

function SpacialListConfig() {
  const [manageData, setManageData] = useState<whiteListProps>({ businessType: 4, businessId: '', visible: false });
  const [applyData, setApplyData] = useState<whiteListProps>({ businessType: 4, businessId: '', visible: false });
  const [getConfig] = useConfig();
  const SpacialListDuccConfig = getConfig('SpacialListDuccConfig', {});

  useEffect(() => {
    window.ACORE = window.ACORE || {};
    (window.ACORE as any).openWhiteListDrawer = {
      showManage(data: whiteListProps) {
        setManageData({ ...data, visible: true });
      },
      showApply(data: whiteListProps) {
        setApplyData({ ...data, visible: true });
      },
      showManageInter: (obj: any) => findValueFromConfig(obj, SpacialListDuccConfig),
    };
  }, [SpacialListDuccConfig]);
  return (
    <>
      {manageData.visible && (
        <Manage setVisible={(val: boolean) => setManageData({ ...manageData, visible: val })} {...manageData} />
      )}
      {applyData.visible && (
        <ApplyWhite setVisible={(val: boolean) => setApplyData({ ...applyData, visible: val })} {...applyData} />
      )}
    </>
  );
}

export default SpacialListConfig;
